import { PageRequest } from '@/core/request/PageRequest';

export enum MailTypeEnum {
  'VALIDATION' = 'VALIDATION',
  'INTERNAL' = 'INTERNAL',
  'QUOTATION_SENT' = 'quotationSent',
  'TYPE' = 'type',
  'QUOTATION_WINNER' = 'quotationWinner',
  'PURCHASE' = 'purchase',
  'INVOICE' = 'NotaFiscal',
  'WORKORDER' = 'workorder',
  'CHECKLIST' = 'checklist',
  'PASSWORD_RECOVERY' = 'PASSWORD_RECOVERY',
  'RECOVERY_OF_DEBTS' = 'RECOVERY_OF_DEBTS',
  'BIRTHDAYS' = 'BIRTHDAYS',
  'CLIENT_WITHOUT_MOVEMENT' = 'CLIENT_WITHOUT_MOVEMENT',
  'CUSTOM' = 'CUSTOM',
  'FUTURE_SERVICES' = 'FUTURE_SERVICES',
  'SATISFACTION_SURVEY' = 'SATISFACTION_SURVEY',
  'EMAIL_MARKETING' = 'EMAIL_MARKETING',
  'NEXT_REVIEWS' = 'NEXT_REVIEWS',
}

export enum MailTypeEnumValue {
  'VALIDATION' = 'VALIDATION',
  'INTERNAL' = 'INTERNAL',
  'quotationSent' = 'QUOTATION_SENT',
  'type' = 'TYPE',
  'quotationWinner' = 'QUOTATION_WINNER',
  'purchase' = 'PURCHASE',
  'NotaFiscal' = 'INVOICE',
  'workorder' = 'WORKORDER',
  'checklist' = 'CHECKLIST',
  'PASSWORD_RECOVERY' = 'PASSWORD_RECOVERY',
  'RECOVERY_OF_DEBTS' = 'RECOVERY_OF_DEBTS',
  'BIRTHDAYS' = 'BIRTHDAYS',
  'CLIENT_WITHOUT_MOVEMENT' = 'CLIENT_WITHOUT_MOVEMENT',
  'CUSTOM' = 'CUSTOM',
  'FUTURE_SERVICES' = 'FUTURE_SERVICES',
  'SATISFACTION_SURVEY' = 'SATISFACTION_SURVEY',
  'EMAIL_MARKETING' = 'EMAIL_MARKETING',
  'NEXT_REVIEWS' = 'NEXT_REVIEWS',
}

export interface MailHistoryParamsInterface extends PageRequest {
  senderId?: number;
  subject?: string;
  userId?: number;
  workOrderId?: number;
}

export interface MailHistoryAttachment {
  content: BlobPart;
  contentType: 'PDF' | ' CSV';
  fileName: string;
}

export interface MailHistoryInterface {
  attachments: MailHistoryAttachment[];
  from: string;
  fromName: string;
  id: string;
  mailType: MailTypeEnum;
  message: string;
  messageType: 'TEXT' | 'HTML';
  sender: 'USER_SENDER' | 'COMPANY_SENDER' | 'MATRIX_SENDER';
  senderId: string;
  sentDate: string;
  subject: string;
  to: string;
  userId: string;
  workorderId: string;
}

export interface MailHistoryFilterInterface {
  from?: string;
  fromName?: string;
  message?: string;
  sentDate?: string;
  to?: string;
  mailType?: MailTypeEnum;
  subject?: string;
}

const mailType: Record<string, string> = {
  [MailTypeEnum.VALIDATION]: 'Validação',
  [MailTypeEnum.INTERNAL]: 'Interno',
  [MailTypeEnum.QUOTATION_SENT]: 'Cotação enviada',
  [MailTypeEnum.TYPE]: 'Tipo',
  [MailTypeEnum.QUOTATION_WINNER]: 'Cotação escolhida',
  [MailTypeEnum.PURCHASE]: 'Compra',
  [MailTypeEnum.INVOICE]: 'Nota Fiscal',
  [MailTypeEnum.WORKORDER]: 'Orçamento',
  [MailTypeEnum.CHECKLIST]: 'Checklist',
  [MailTypeEnum.PASSWORD_RECOVERY]: 'Recuperar Senha',
  [MailTypeEnum.BIRTHDAYS]: 'Aniversário',
  [MailTypeEnum.CLIENT_WITHOUT_MOVEMENT]: 'Cliente sem movimentação',
  [MailTypeEnum.RECOVERY_OF_DEBTS]: 'Cobrança',
  [MailTypeEnum.CUSTOM]: 'Customizável',
  [MailTypeEnum.EMAIL_MARKETING]: 'E-mail marketing',
  [MailTypeEnum.SATISFACTION_SURVEY]: 'Pesquisa de satisfação',
  [MailTypeEnum.NEXT_REVIEWS]: 'Próxima revisão',
  [MailTypeEnum.FUTURE_SERVICES]: 'Serviços futuros',
};

export { mailType };
